// extracted by mini-css-extract-plugin
module.exports = {"nameOnCard":"freedompay_nameOnCard__1Scyx","nameOnCardLabel":"freedompay_nameOnCardLabel__mulW9"};